// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';
import media from '../../../../helpers/media';

type Props = {
  boxed: boolean,
};

export default styled<any, Theme, Props>('section')`
  background-color: ${props => props.theme.cart.backgroundColor};
  padding: 1.5rem;

  ${props => props.boxed && css`
    border-radius: ${props.theme.cart.borderRadius};
    border:  1px solid ${props.theme.cart.borderColor};
    display: flex;
    flex-direction: column;

    ${media.md(css`
      flex-direction: row;
    `)}

    ${media.lg(css`
      display: block;
    `)}
  `}

  ${media.lg(css`
    border-radius: ${props => props.theme.cart.borderRadius};
    border:  1px solid ${props => props.theme.cart.borderColor};
  `)}
`;
